import { InertiaLinkProps, Link as InertiaLink } from '@inertiajs/react';
import { twMerge } from 'tailwind-merge';
import React from 'react';

type LinkProps = InertiaLinkProps;

export const Link = ({ as = 'Link', className, children, ...rest }: LinkProps) => {
    if (as === 'Link') {
        // @ts-ignore
        as = InertiaLink;
    }

    return React.createElement(as, {
        ...rest,
        className: twMerge(
            'hover:underline text-primary focus:ring-2 focus:ring-primary/50 focus:ring-offset-2 focus:ring-offset-surface-1',
            className
        )
    }, children);
};
